export const deleteCardQuery = `
mutation carddetail($id :JSON){
    CarddetailsDeleteById(id:$id)
  }
`;
